import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy path — canonical terms live at /terms. */
export const Route = createFileRoute("/legal/terms")({
  beforeLoad: () => {
    throw redirect({ to: "/terms", replace: true });
  },
});
